@if (isReadOnly()) {
  <div class="w-full h-full">
    <div class="flex flex-col gap-3">
      <div class="self-stretch justify-start text-text-color text-base font-medium font-['Inter'] leading-6">CLC Staff Members</div>

      <div class="grid [grid-template-columns:max-content_auto_auto_auto] lg:w-2/3 w-full items-center border border-surface-400 rounded-lg">
<!--          Header-->
        <div class="h-full">
        </div>
        <div class="flex flex-col px-4 py-3 gap-3">
          <div class="self-stretch justify-start text-datatable-header-cell-color text-base font-normal font-['Roboto_Condensed']">Traveller</div>
        </div>
        <div class="flex flex-col px-4 py-3 gap-3">
          <div class="self-stretch justify-start text-datatable-header-cell-color text-base font-normal font-['Roboto_Condensed']">Traveller Will Acquit</div>
        </div>
        <div class="flex flex-col px-4 py-3 gap-3">
          <div class="self-stretch justify-start text-datatable-header-cell-color text-base font-normal font-['Roboto_Condensed']">Pre-payment Requested</div>
        </div>
<!--          Readonly Travellers-->
        @for (traveller of sortedTravellers(); track traveller.travellerId ?? traveller.details?.id) {
          <div class="col-span-4 h-[1px] bg-surface-200"></div>
          <div class="px-4 py-3">
            @if (isPrimary(traveller)) {
              <i class="fa fa-star text-yellow-500"></i>
            }
          </div>
          <div class="px-4 py-3">
            <span class="text-xs font-bold font-['Roboto_Condensed'] text-primary-900">{{ traveller.details?.name }}</span>
          </div>
          <div class="px-4 py-3 flex items-center">
            <p-checkbox [ngModel]="traveller.isSelfAcquit" [binary]="true" disabled />
          </div>
          <div class="px-4 py-3 flex items-center">
            <p-checkbox [ngModel]="false" [binary]="true" disabled />
          </div>
        } @empty {
          <div class="col-span-4 h-[1px] bg-surface-200"></div>
          <div class="col-span-4 text-xs font-normal font-['Inter'] px-4 py-3"><i>No travellers.</i></div>
        }
      </div>
    </div>
  </div>
} @else {
  <div class="w-full h-full flex flex-col gap-6">
    <p-card>
      <div class="flex gap-2">
        <div class="flex flex-col w-64 bg-surface-0 p-6 gap-6 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
          <div class="self-stretch justify-start text-surface-800 text-base font-medium font-['Inter'] leading-6">CLC Staff Members<span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
          <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">List all travelling CLC staff.</div>
          <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']"><i><b>Pre-payment</b> options CANNOT be set in a template.</i></div>
          <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']"><i>This option will be available when creating a TA based on this template.</i></div>
        </div>

        <div class="flex-1 flex flex-col bg-surface-50 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
          <div class="grid [grid-template-columns:max-content_1fr_1fr_1fr_1fr] w-full bg-surface-0">
    <!--        Header-->
            <div class="">
            </div>
            <div class="flex flex-col px-4 py-2.5 gap-3">
              <div class="self-stretch justify-start text-datatable-header-cell-color text-base font-normal font-['Roboto_Condensed']">Person Travelling</div>
            </div>
            <div class="flex flex-col px-4 py-2.5 gap-3">
              <div class="self-stretch justify-start text-datatable-header-cell-color text-base font-normal font-['Roboto_Condensed']">Traveller Will Acquit</div>
            </div>
            <div class="flex flex-col px-4 py-2.5 gap-3">
              <div class="self-stretch justify-start text-datatable-header-cell-color text-base font-normal font-['Roboto_Condensed']">Pre-payment Requested</div>
            </div>
            <div class="flex flex-col px-4 py-2.5 gap-3">
              <div class="self-stretch justify-start text-datatable-header-cell-color text-base font-normal font-['Roboto_Condensed']">Add/Remove Travellers</div>
            </div>

            <div class="col-span-5 h-[1px] bg-surface-200"></div>
    <!--        Travellers-->
            @for (traveller of sortedTravellers(); track traveller.travellerId ?? traveller.details?.id) {
              <div class="px-4 py-3">
                @if (isPrimary(traveller)) {
                  <p-button [rounded]="true" [text]="true" severity="secondary">
                    <i class="fa fa-star text-yellow-500"></i>
                  </p-button>
                } @else if (traveller.details?.userType !== UserType.Casual) {
                  <p-button [rounded]="true" [text]="true" severity="secondary" (onClick)="addPrimaryRole(traveller)"
                            data-testid="template-traveller-make-primary">
                    <i class="fa-light fa-star text-surface-500"></i>
                  </p-button>
                }
              </div>
              <div class="px-4 py-3" [class.bg-yellow-50]="traveller.details?.userType === UserType.Casual">
                <p-autocomplete [ngModel]="traveller.details?.name + ' ' + getUserTypeSuffix(traveller.details)"
                                [dropdown]="true"
                                disabled
                                [styleClass]="traveller.details?.userType === UserType.Casual ? 'bg-yellow-50' : ''"
                                panelStyleClass="text-xs font-bold font-['Roboto_Condensed'] text-primary-900"
                                placeholder="Type and/or select..."
                                size="small"
                                [forceSelection]="true"
                ></p-autocomplete>
              </div>
              <div class="px-4 py-3 flex items-center">
                <p-checkbox
                  [ngModel]="traveller.isSelfAcquit"
                  (onChange)="updateTravellerAcquittal($event.checked, traveller)"
                  [disabled]="isAcquitDisabled(traveller)"
                  [binary]="true"
                />
              </div>
              <div class="px-4 py-3 flex items-center">
                <p-checkbox [ngModel]="false" [binary]="true" disabled />
              </div>
              <div class="px-4 py-3">
                <p-button severity="danger" size="small" (onClick)="removeStaffTraveller(traveller)" [text]="true"
                          data-testid="template-traveller-remove">
                  <div class="flex items-center gap-2">
                    <div class="rounded-full w-5 h-5 flex items-center justify-center text-white bg-red-500 text-lg font-medium">
                      <i class="fa-solid fa-minus fa-2xs"></i>
                    </div>
                    <span class="text-xs font-normal font-['Roboto_Condensed'] text-primary-900">Remove</span>
                  </div>
                </p-button>
              </div>
              <div class="col-span-5 h-[1px] bg-surface-200"></div>
            }
    <!--        Empty Traveller-->
            <div class="px-4 py-3">
            </div>
            <div class="px-4 py-3">
              <p-autocomplete [(ngModel)]="emptyTraveller"
                              [dropdown]="true"
                              [suggestions]="filteredTravellers"
                              (completeMethod)="filterTravellers($event)"
                              [forceSelection]="true"
                              panelStyleClass="text-xs font-bold font-['Roboto_Condensed'] text-primary-900"
                              placeholder="Start typing and/or select..."
                              size="small"
                              (onSelect)="addStaffTraveller($event.value)"
                              [optionLabel]="getTravellersFullName"
                              data-testid="template-traveller-add">
                <ng-template let-traveller #item>
                  <span class="text-xs font-bold font-['Roboto_Condensed'] text-primary-900 block"
                        [class.bg-yellow-50]="traveller.details?.userType === UserType.Casual" title="{{traveller.details?.email}}">
                    {{ getTravellersFullName(traveller) }} {{ getUserTypeSuffix(traveller.details) }}
                  </span>
                </ng-template>
                <ng-template let-traveller #selectedItem>
                  <span class="text-xs font-bold font-['Roboto_Condensed'] text-primary-900 block"
                        [class.bg-yellow-50]="traveller.details?.userType === UserType.Casual" title="{{traveller.details?.email}}">
                      {{ getTravellersFullName(traveller) }} {{ getUserTypeSuffix(traveller.details) }}
                  </span>
                </ng-template>
              </p-autocomplete>
            </div>
            <div class="px-4 py-3"></div>
            <div class="px-4 py-3"></div>
            <div class="px-4 py-3"></div>
            <div class="col-span-5 h-[1px] bg-surface-200"></div>
          </div>
          <div class="w-full flex-1 bg-surface-0"></div>
        </div>
      </div>
    </p-card>
  </div>
}
